import '~/js/modules/stickyNav';
import '~/js/modules/countdown';
import '~/js/modules/subscribe-form';
import FeaturedResorts from '~/js/components/specials/home/FeaturedResorts';
import GoFetch from '~/js/modules/fetch-wrapper.js';

const fetch = new GoFetch();
const featuredResorts = document.querySelector('#js-featured-resorts');
const minimumRates = beaches_app.page.minimumRates;
const offerList = beaches_app.page.offers;
const resortPercentageOff = [...beaches_app.page.resortPercentageOff];
const resortsSummary = beaches_app.page.resortsSummary;

ReactDOM.render(
  <FeaturedResorts
    minimumRates={minimumRates}
    offerList={offerList}
    resortPercentageOff={resortPercentageOff}
    resortsSummary={resortsSummary}
    cdnURL={beaches_app.page.cdnURL}
  />, featuredResorts
);

const viewOfferDetailsModal = $('#summer-sale-modal');

fetch.post('/fetchPromotion/?promo_ids=110341', null)
  .then(response => {
    const promotion = response.data.promotions[0].promotion;

    viewOfferDetailsModal.find('.modal-content').html(promotion.description);
  });
